import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { brand } from "../../../../../config/brands";
import OrthoCheckLogo from "../../../../assets/images/orthocheck/orthocheck.svg";
import DentalCheckLogo from "../../../../assets/images/orthocheck/dentalcheck.svg";
import apiHandler from "../../orthocheck/api";
import LoadingScreen from "../../../../../components/custom/LoadingScreen";
import { MuscleTypes } from "../../../../util/utils";

const checkerLogo = brand.key === "mdp" ? DentalCheckLogo : OrthoCheckLogo;

const OrthoCheck = ({ knowsAbout, isPractice }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [bodyParts, setBodyParts] = useState([]);

  const handleBodyPartClick = (item) => {
    const apikey = localStorage.getItem("provider_api_key");
    navigate(`/orthocheck?path=/${item.slug}/questions&key=${apikey}`);
  };

  const generateBodyParts = (resultData) => {
    const filteredMuscleTypes = MuscleTypes.reduce((acc, muscle) => {
      if (resultData.includes(muscle.bodyPart)) {
        acc.push(muscle);
      }
      return acc;
    }, []);
    if (filteredMuscleTypes.length > 0) {
      return filteredMuscleTypes;
    }
  };

  const getBodyParts = async () => {
    const xApiKey = localStorage.getItem("provider_api_key");
    return await apiHandler({
      method: "post",
      url: `/bodyparts`,
      headers: { "X-API-KEY": xApiKey },
    })
      .then((response) => {
        if (response) {
          const { bodyParts } = response;
          const generatedBodyParts = generateBodyParts(bodyParts);
          setBodyParts(generatedBodyParts);
        } else {
          setBodyParts(MuscleTypes);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error getting body parts:", error);
      });
  };

  useEffect(() => {
    getBodyParts();
  }, []);

  return (
    <section className="container pt-5 ortho-check">
      <div className="d-flex justify-content-between align-items-center flex-wrap mb-5">
        <div className="flex-grow-1">
          <h5 className="fw-bold mb-1 ortho-font">
            Your {brand.key === "mdp" ? "dental" : "orthopedic"} diagnosis in
            less than 90 seconds
          </h5>
          <p className="text-muted mb-0 ortho-child-font">
            What is the source of your pain?
          </p>
        </div>
        <div className="flex-shrink-0 orthocheck-mob">
          <img
            src={checkerLogo}
            alt={brand.checkerName}
            className="ortho-logo"
          />
        </div>
      </div>
      {isLoading ? (
        <div className="flex justify-center items-center min-h-[calc(100vh-200px)] my-20">
          <LoadingScreen color="primary" />
        </div>
      ) : (
        <React.Fragment>
          <div className="row g-3 mb-5 position-relative justify-content-center">
            {bodyParts.map((item, index) => (
              <div
                key={index}
                className="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-1-5 text-center text-decoration-none hover-link"
                onClick={() => handleBodyPartClick(item)}
                style={{ cursor: "pointer" }}
              >
                <div className="rounded icon-box mx-auto">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="img-fluid"
                    style={{ maxHeight: "50px" }}
                  />
                </div>
                <p className="mb-0 mt-2 fw-bold text-black">{item.name}</p>
              </div>
            ))}
          </div>
          <hr className="ortho-dashed-line" />
        </React.Fragment>
      )}
      <div className="text-center mt-5">
        <h5 className="fw-bold mb-3 ct-text">
          {brand.key === "mdp"
            ? "Do you have mouth or jaw pain?"
            : "Do you have muscle or joint pain?"}
        </h5>
        <button
          className="button rounded-pill fw-bold"
          style={{ padding: "20px 66px" }}
          onClick={() =>
            (window.location.href = `${brand.webUrl}${brand.educationPath}`)
          }
        >
          Explore Conditions & Treatments
        </button>
      </div>
    </section>
  );
};

export default OrthoCheck;
